import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useOrg } from '../context/OrgContext';

function Navbar() {
  const { logout } = useAuth();
  const { isOrgUser, orgSlug, orgName, orgLogoUrl, orgBrandColor } = useOrg();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Detect slug from URL params (for org-scoped routes)
  const params = useParams();
  const slug = params.slug || orgSlug;

  // Prefix helper: org users get /org/:slug prefix
  const p = (path) => (isOrgUser && slug) ? `/org/${slug}${path}` : path;

  const handleLogout = () => {
    logout();
    navigate('/login');
    setMobileMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleNavClick = (path) => {
    navigate(p(path));
    closeMobileMenu();
  };

  const scrollToSafetyBanner = () => {
    const banner = document.querySelector('.trust-banner');
    if (banner) {
      banner.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <div className="navbar">
        <div className="navbar-header">
          <h1>
            <img src="/belong.png" alt="Belong" style={{ height: '32px', verticalAlign: 'middle', marginRight: '4px' }} />
            {isOrgUser && slug && (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', marginLeft: '6px' }}>
                <span style={{ color: '#9ca3af', fontSize: '14px' }}>×</span>
                {orgLogoUrl
                  ? <img src={orgLogoUrl} alt={orgName} style={{ height: '24px', borderRadius: '4px', verticalAlign: 'middle' }} onError={(e) => e.target.style.display = 'none'} />
                  : <span style={{ fontSize: '13px', color: orgBrandColor || '#7C3AED', fontWeight: '700' }}>{orgName}</span>
                }
              </span>
            )}
            {' '}
            <span
              className="safety-icon"
              title="Privacy-first platform - Click to learn more"
              onClick={scrollToSafetyBanner}
              aria-hidden="true"
            >
              🛡️
            </span>
          </h1>
          
          {/* Hamburger menu button - mobile only */}
          <button
            className="hamburger-btn nav-mobile-only"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
          >
            ☰
          </button>
        </div>
        
        <nav className="navbar-links">
          {/* Always visible on mobile */}
          <a href={p('/dashboard')}>Home</a>
          <a href={p('/discovery')}>Find people</a>
          <a href={p('/connections')}>Connections</a>
          
          {/* Desktop only - hidden on mobile */}
          <a href={p('/groups')} className="nav-desktop-only">Groups</a>
          <a href={p('/events')} className="nav-desktop-only">Events</a>
          <a href={p('/messages')} className="nav-desktop-only">Messages</a>
          <a href={p('/profile')} className="nav-desktop-only">You</a>
          <button
            onClick={handleLogout}
            className="nav-desktop-only"
          >
            Logout
          </button>
        </nav>
      </div>

      {/* Mobile menu overlay */}
      <div 
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />

      {/* Mobile menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <h2>Menu</h2>
          <button 
            className="mobile-menu-close"
            onClick={closeMobileMenu}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>
        <nav>
          <a href={p('/groups')} onClick={() => handleNavClick('/groups')}>Groups</a>
          <a href={p('/events')} onClick={() => handleNavClick('/events')}>Events</a>
          <a href={p('/messages')} onClick={() => handleNavClick('/messages')}>Messages</a>
          <a href={p('/profile')} onClick={() => handleNavClick('/profile')}>You</a>
          <button onClick={handleLogout}>Logout</button>
        </nav>
      </div>
    </>
  );
}

export default Navbar;
